import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { SeriesService } from 'src/app/Core/services/series.service';
import { UtilService } from 'src/app/Core/services/util.service';
interface Category {
  category_id: string;
  category_name: string;
}

interface Series {
 // backdrop_path: []
// cast:string 
category_id:string 
cover:string 
// director:string 
// episode_run_time:string 
// genre:string 
// last_modified:string 
name: string
// num:number
// plot:string; 
// rating: string;
// rating_5based: number;
// releaseDate:string; 
series_id:string;
// tmdb_id:number;
// youtube_trailer:string;
}
@Component({
  selector: 'app-series',
  templateUrl: './series.component.html',
  styleUrls: ['./series.component.css']
})
export class SeriesComponent implements OnInit {
  isLoading: any;
  isCategory = true;
  // categories: any;
  categoryId: any;
  id:boolean=false
  selectedcategory: any;
  defaultCategoryList: any;
  filterTerm: string;
  allSeriesCat:any
  isDesc: boolean = true;
  laodCategories:boolean = false;
  column: string = 'CategoryName';
  sortButton: any = [{ label: 'Default', val: 'default', selected: true },
  { label: 'A - Z', val: 'atoz', selected: false },
  { label: 'Z - A', val: 'ztoa', selected: false },
  ];
  translate = ['COMMON.DEFAULT','COMMON.A-Z','COMMON.Z-A']
  //dexiedb
  categories: Category[] = [];
  searchedCategory:Category[]=[]
  series: Series[] = [];
  selectedCategoryId = '';
  page = 1;
  limit = 50;
  serie:any
  searchTextChannel:any;


  constructor(private utilService: UtilService, private seriesService: SeriesService, private route: ActivatedRoute,private http:HttpClient) {
    this.route.queryParams.subscribe((param: any) => {
     this.categoryId = String(param['id']) || 'all';
    this.updateSelectedId(this.categoryId); // your logic to highlight and filter
    })
  }

 async ngOnInit() {
  this.categories = await this.seriesService.loadCategories();
  this.defaultCategoryList = this.categories;
  this.searchedCategory = this.defaultCategoryList;
  // const total = await this.seriesService.loadSeries();
  // if(total){
  //   this.id = true;
  //   this.updateSelectedId('all')
  // }
   if(this.categoryId == 'all'){
     this.id = true;
     this.updateSelectedId('all');
    }else if(this.categoryId !== 'undefined'){
      console.log(this.categoryId);
      this.updateSelectedId(this.categoryId);
    }else{
      this.id = true;
     this.updateSelectedId('all');
    }


  }

  updateSelectedId(categoryId:string){
    console.log(categoryId);
    this.isCategory = false;
    if(categoryId == 'all'){
      this.selectedcategory = categoryId;
      this.id = true;
      this.categories?.map((ele: any, index) => {
        (ele.category_id == categoryId) ? ele.select = true : ele.select = false;
      });
    }else{
      this.selectedcategory = categoryId;
      this.id = false;
      this.categories?.map((ele: any, index) => {
        (ele.category_id == categoryId) ? ele.select = true : ele.select = false;
      });
    }
    
  }

  getSeriesCategory() {
    this.utilService.showSpinner()
    this.isLoading = true;
    this.seriesService.getSeriesCategories().subscribe((res: any) => {
    if(res.content){
      console.log(res.content);
      this.categories = res.content;
      this.defaultCategoryList = res.content;
      if (this.categories) {
        this.categories.map((ele: any, index) => {
          if (this.categoryId) {
            
            if (ele.category_id == this.categoryId) {
              ele.select = true;
            }
          } else {
            if (index == 0) {
              ele.select = true;
              this.updateCategory(ele.category_id);
              // this.updateCategory(null);
              this.id =true
              
            }
            else { ele.select = false; }
          }
          // if (index == 0) {
            //   ele.select = true;
            //   this.updateCategory(ele.category_id)
          // } else { ele.select = false; }
        });
      }
    }
    else{
      this.utilService.hideSpinner()
      this.isLoading = false;
      this.categories = res;
      this.defaultCategoryList = res;
      if (this.categories) {
        this.categories.map((ele: any, index) => {
          if (this.categoryId) {
            
            if (ele.category_id == this.categoryId) {
              ele.select = true;
            }
          } else {
            if (index == 0) {
              ele.select = true;
              this.updateCategory(ele.category_id);
              // this.updateCategory(null);
              this.id =true
              
            }
            else { ele.select = false; }
          }
          // if (index == 0) {
            //   ele.select = true;
            //   this.updateCategory(ele.category_id)
          // } else { ele.select = false; }
        });
      }
    }
    }, err => {
      this.isLoading = false;
      this.laodCategories =true;
    this.utilService.hideSpinner()
    this.utilService.showErrorCall(err);
    });
  }

  loadSeriesCategories(){
    this.isLoading = true;
    this.seriesService.getSeriesCategories().subscribe((res: any) => {
    if(res){
      this.utilService.hideSpinner()
      this.isLoading = false;
      this.categories = res;
      this.laodCategories =false;
      this.defaultCategoryList = res;
      if (this.categories) {
        this.categories.map((ele: any, index) => {
          if (this.categoryId) {
            
            if (ele.category_id == this.categoryId) {
              ele.select = true;
            }
          } else {
            if (index == 0) {
              ele.select = true;
              this.updateCategory(ele.category_id);
              // this.updateCategory(null);
              this.id =true
              
            }
            else { ele.select = false; }
          }
          // if (index == 0) {
            //   ele.select = true;
            //   this.updateCategory(ele.category_id)
          // } else { ele.select = false; }
        });
      }
    }
    }, err => {
      this.isLoading = false;
      this.laodCategories =true;
      this.utilService.hideSpinner()
      this.utilService.showErrorCall(err);
    });
  }

  updateCategory(id) {
    this.isLoading = true;
    this.utilService.showSpinner()
    this.utilService.filterResetObservable.next(true);
    
    if(id === null){
      this.seriesService.selectedCategoryWiseSeriesLists().subscribe((res: any) => {
        this.utilService.hideSpinner()
        this.isLoading = false;
        this.id = true
          if (res.content){
              this.allSeriesCat = res.content;
              this.selectedcategory = this.allSeriesCat;
            }
            else{
            this.allSeriesCat = res.slice(0,2000)
            this.selectedcategory = this.allSeriesCat;
          }
        }, err => {
        this.utilService.hideSpinner()
        this.isLoading = false;
          this.utilService.showErrorCall(err);
        });
    }
    else{
    this.seriesService.selectedCategoryWiseSeriesList(id).subscribe((res: any) => {
    this.utilService.hideSpinner()
    this.isLoading = false;
    this.id = false
      if (res.content)
      {
        this.selectedcategory = res.content;

      }else
        {
        this.selectedcategory = res;
      }
    }, err => {
    this.utilService.hideSpinner()
    this.isLoading = false;
      this.utilService.showErrorCall(err);
    });
    }
    this.categories?.map((ele: any, index) => {
      (ele.category_id == id) ? ele.select = true : ele.select = false;
    });
    
  }

  // sort(property) {
  //   // this.isDesc = !this.isDesc;
  //   // this.utilService.commonSort(this.isDesc, property, this.categories);
  // };
  sort(property, subtype: any) {
    let ascDesc;
    this.sortButton.map((ele: any) => {
      (subtype == ele.val) ? ele.selected = true : ele.selected = false;
    });

    if (subtype == 'default') {
      this.searchedCategory = this.defaultCategoryList;
    } else {
      (subtype == 'atoz') ? ascDesc = 'asc' : ascDesc = 'desc';
    }
    if (ascDesc) {
      this.clearSearchChannel()
      this.utilService.sortCommonCategorywise(property, ascDesc, this.categories, (callback) => {
        this.searchedCategory = callback;
      });
    }

  }

  searchTextsChannel(ev){
        let search = this.searchTextChannel.toLowerCase();

    this.filterTerm = search;
    if(this.searchTextChannel.length > 0){
     this.searchedCategory = this.defaultCategoryList.filter((item: any) =>
          item.category_name.toLowerCase().includes(search.toLowerCase())
      );
      console.log(this.searchedCategory);
      
    }else{
      this.searchedCategory = this.defaultCategoryList;
    }
    
  }
  clearSearchChannel(){
    this.searchTextChannel ='';
    this.searchedCategory = this.defaultCategoryList;
    
  }

  translateFilter(index:any):string{
    return this.translate[index]
  }
  
}
